import React from 'react';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { contact } from '../data/contact';
export function ProfileFooter() {
  return <footer className="bg-cream-dark text-white" data-id="element-166" data-mp="35plwnronu7qo">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-6 py-14 md:flex-row md:items-end md:justify-between md:px-10 lg:px-[4.5rem]" data-id="element-167" data-mp="3kl1xqgnnr3wk">
        <div data-id="element-168" data-mp="3fmgyajg8co96">
          <div className="flex items-center gap-3" data-id="element-169" data-mp="3fjupyhlim4pw">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white/5 ring-2 ring-wheat/70" data-id="element-170" data-mp="2rx5zh7ifx3xo">
              <span className="font-serif text-sm font-semibold text-wheat" data-id="element-171" data-mp="2myut56rctbk7">JG</span>
            </span>
            <p className="font-serif text-xl" data-id="element-172" data-mp="31n8uted1atz6">James Eric Godfrey OBE</p>
          </div>
          <ul className="mt-6 space-y-2 text-sm text-white/70" data-id="element-173" data-mp="2wtmr4boum0fi">
            <li className="flex items-center gap-2" data-id="element-174" data-mp="2953l62t9tzql">
              <MapPinIcon className="h-4 w-4 text-wheat" aria-hidden="true" data-id="element-175" data-mp="293ini4bnu0oi" />
              {contact.location}
            </li>
            <li data-id="element-176" data-mp="27ejswg47fbaa">
              <a href={`mailto:${contact.email}`} className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-white" data-id="element-177" data-mp="27f3ce19i67qf">
                <MailIcon className="h-4 w-4 text-wheat" aria-hidden="true" data-id="element-178" data-mp="2be2fdgbobuf8" />
                {contact.email}
              </a>
            </li>
            <li data-id="element-179" data-mp="2l5f2xvqfvyfg">
              <a href={contact.phoneHref} className="inline-flex items-center gap-2 tabular-nums transition-colors duration-150 hover:text-white" data-id="element-180" data-mp="2l5ydusho9mjz">
                <PhoneIcon className="h-4 w-4 text-wheat" aria-hidden="true" data-id="element-181" data-mp="1ohiooxih5f7e" />
                {contact.phoneDisplay}
              </a>
            </li>
          </ul>
        </div>
        <p className="text-xs text-white/55" data-id="element-182" data-mp="1xej80pqosn3z">Married to Janet, three children</p>
      </div>
    </footer>;
}